<template>
  <main id="main">
    <transition name="fade" mode="out-in" @before-enter="onBeforeEnter" @leave="onLeave" @after-leave="onAfterLeave">
      <router-view></router-view>
    </transition>
  </main>
</template>
<script>
import { mapActions, mapState } from "pinia";
import { useMainStore } from "@/store/main";

export default {
  name: 'Main',
  props: {
  },
  computed: {
    ...mapState(useMainStore,['isMobile']),
  },
  data: () => {
    return {
    }
  },
  watch: {
    $route(to, from) {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop || 0;
      let currentTarget, nextTarget;

      if (from.path === to.path && to.path === '/') {
        // 同頁切換
      } else {
        // 不同頁切換
        const currentName = from.path === '/' ? 'home' : from.path.replace('/', '');
        currentTarget = document.querySelector(`.page-${currentName}`)
      }

      if (currentTarget) {
        currentTarget.style.position = 'fixed';
        currentTarget.style.top = `${scrollTop * -1}px`;
      }

      // window.scrollTo({
      //   top: 0,
      //   left: 0,
      //   behavior: 'smooth'
      // });
    },
  },
  methods: {
    onBeforeEnter() { },
    onLeave() {
      // const sections = document.querySelectorAll('.section')
      // sections[1].classList.add('play')
    },
    onAfterLeave() { },
  },
  mounted() {
  },
  components: {
  }
}
</script>

<style lang="scss">
$assets: '~@/assets/images/common/';

#main {

  position: relative;
  width: 100%;
  height: auto;
  min-height: calc(var(--vh, 1vh) * 100);
  margin: 0 auto;
  z-index: 1;
  // padding-top: 64px;
  .page {
    width: 100%;
    height: auto;
    min-height: calc(var(--vh, 1vh) * 100);
  }

}

.section {
  position: relative;

  @include tablet {}
}

.section__inner {
  @include inner;
  position: relative;

  @include tablet {}
}
</style>
